module.exports = __webpack_public_path__ + "static/media/whatsapp_icon.fdf78b34.svg";